import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InternalService {
  private isInternal = signal(false);

  getIsInternal() {
    return this.isInternal.asReadonly();
  }

  setIsInternal(isInternal: boolean) {
    this.isInternal.set(isInternal);
  }
}
